import { isLocal } from "@/config/env";
import BrowserLogger from "alife-logger";

const create = () => {
  if (isLocal) {
    return;
  }

  // https://help.aliyun.com/zh/arms/browser-monitoring/getting-started/implement-browser-monitoring-by-using-npm
  const tag = "sdichome-h5";
  const bl = BrowserLogger.singleton({
    pid: "g3beeayvxk@c7ad87ca474ef95",
    appType: "web",
    imgUrl: "https://arms-retcode.aliyuncs.com/r.png?",
    tag,
    release: `${tag}-${process.env.REACT_APP_BUILD_TIME?.replace(/\/|\s|:/g, "") || ""}`,
  });

  return bl;
};

const bl = create();

export default bl;
